import * as React from 'react';
import Table from "../../Table";
import {useCallback, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {AppUser, TherapySession} from "../../../types";
import {getTherapySessions, getUsers} from "../../../api";
import dateFormat  from "dateformat";
const dateParse = require('date-format');


const SearchTherapySessions: React.FunctionComponent = () => {

    const [therapySessions, setTherapySessions] = useState<TherapySession[]>();
    const [users, setUsers] = useState<AppUser[]>();
    const [therapist, setTherapist] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [doLoad, setDoLoad] = useState(true);

    const search = useCallback(() => {
        if(doLoad) {
            setDoLoad(false);
            getTherapySessions(therapist, fromDate, toDate)
                .then((tz) => {
                    setTherapySessions(tz);
                })
                .catch((e) => console.log(e))
                .finally(() => {
                })
        }
    }, [therapist, fromDate, toDate, doLoad])

    useEffect(() => {
        search();
        getUsers()
            .then((uz) => {
                setUsers(uz);
            })
            .catch((e) => console.log(e))
            .finally(() => {
            })


    }, [search]);

    return (<>
        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Therapy Sessions</h2>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <Link to={"/m/therapy-sessions/add"}>
                    <button className={"btn btn-primary"}>Add Therapy Session</button>
                </Link>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    setDoLoad(true);
                }}>
                    <div className="form-row align-items-center">

                        <div className="col-sm-2 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">Therapist</label>
                            <select id="inputState" className="form-control" value={therapist}
                                    onChange={(e) => setTherapist(e.target.value)}>
                                <option key={"u_0"} value={""}>Select a therapist...</option>
                                {
                                    users?.map((u) => (
                                        <option key={u.uuid} value={u.uuid}>{u.lastName + ", " + u.firstName}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">From Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName"
                                   value={fromDate}
                                   onChange={(e) => setFromDate(e.target.value)}
                                   placeholder={"Start Date"} autoComplete={"new-password"}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">To Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName"
                                   placeholder={"End Date"}
                                   value={toDate}
                                   onChange={(e) => setToDate(e.target.value)}
                                   autoComplete={"new-password"}/>
                        </div>
                        <div className="col-auto my-1">
                            <button type="submit" className="btn btn-primary">Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <Table headers={["Date", "Time", "Therapist", "Status"]}
                       defaultPaginationSize={25}>
                    {
                        therapySessions?.map((t) => (
                            <tr key={t.uuid}>
                                <td>
                                    <Link to={"/m/therapy-sessions/view/" + t.uuid}>
                                        {dateFormat(dateParse.parse("yyyy-mm-dd", t.date),"yyyy-MM-dd")}
                                    </Link>
                                </td>
                                <td>
                                    {dateFormat( dateParse.parse("hh:mm", t.startTime), "hh:MM TT")}
                                </td>
                                <td>
                                    {t.therapist.firstName + " " + t.therapist.lastName}
                                </td>
                                <td>
                                    {t.status}
                                </td>

                                <td>


                                </td>
                            </tr>
                        ))
                    }

                </Table>
            </div>
        </div>
    </>);
};

export default SearchTherapySessions;